import { v4 as uuidv4 } from 'uuid';
import { generateOneLoginDestinationUrl } from '@americanexpress/virtual-cards-commons/src/hooks/utils/generateOneLoginDestinationUrl';
import { redirect } from '@americanexpress/virtual-cards-commons/src/hooks/utils/redirect';
import { READ_USER_SESSION, reportError } from '@americanexpress/virtual-cards-commons';
import { MODULE_IDS, ERROR_LOG_MESSAGES } from '../utils/constants';

/**
 * onEnter hook that verifies the user session is valid by calling
 * ReadUserSession.v1 on the Java backend.
 */
const redirectToLogin = (store, nextState, replace) => {
  const state = store.getState();
  const oneLoginUrl = state.getIn(['config', 'oneLoginUrl']);
  const browserOrigin = state.getIn(['browser', 'location', 'origin']);
  const loginUrl = generateOneLoginDestinationUrl(
    oneLoginUrl,
    browserOrigin,
    nextState.location.pathname + (nextState.location.search || '')
  );

  redirect(loginUrl, replace);
};

const requireValidSession = (store) => async (nextState, replace, callback) => {
  if (!global.BROWSER) {
    callback();
    return;
  }

  const { getState } = store;
  const correlationId = uuidv4();
  const faasApiUrl = getState().getIn(['config', 'faasApiUrl']);

  try {
    const readUserSession = await fetch(`${faasApiUrl}/${READ_USER_SESSION}`, {
      method: 'POST',
      body: '{}',
      headers: {
        'one-data-correlation-id': correlationId,
      },
      credentials: 'include',
    });

    const hasValidSession = Boolean(readUserSession) && readUserSession.status === 200;

    // Do not continue route transition when session is invalid.
    if (!hasValidSession) {
      store.dispatch(reportError(
        new Error(`${ERROR_LOG_MESSAGES.REQUIRE_VALID_SESSION_ERROR} ${readUserSession?.status}`),
        { collectionMethod: 'onEnter', moduleName: MODULE_IDS.REQUIRE_VALID_SESSION, transactionId: correlationId }
      ));
      redirectToLogin(store, nextState, replace);
      return;
    }

    callback();
  } catch (err) {
    // Network error or other fetch failure
    store.dispatch(reportError(err, {
      collectionMethod: 'onEnter',
      moduleName: MODULE_IDS.REQUIRE_VALID_SESSION,
      transactionId: correlationId,
    }));
    redirectToLogin(store, nextState, replace);
  }
};

export default requireValidSession;
